/**
 * 斐波SDK-TDK各页面映射
 * @author wangxuejin
 * @since 2021-3-6
 */

export const PAGE_TDK_TYPE = {
  /**
   * 官网-总首页
   */
  HOME: {
    type: 'HOME',
    name: '首页',
    route: '/',
  },
  /**
   * 模板市场-推荐
   */
  TEMPLATE: {
    type: 'TEMPLATE',
    name: '模板市场-推荐',
    route: '/template/',
  },
  /**
   * 模板市场-翻页
   */
  MULTIPAGE: {
    type: 'MULTIPAGE',
    name: '模板市场-翻页',
    route: '/template/multipage.html',
  },
  /**
   * 模板市场-长页
   */
  LONGPAGE: {
    type: 'LONGPAGE',
    name: '模板市场-长页',
    route: '/template/longpage.html',
  },
  /**
   * 模板市场-展示页（翻页、长页合并为展示页）
   */
  SHOWPAGE: {
    type: 'SHOWPAGE',
    name: '模板市场-展示页',
    route: '/template/showpage.html',
  },
  /**
   * 模板市场-短视频
   */
  SHORTVIDEO: {
    type: 'SHORTVIDEO',
    name: '模板市场-短视频',
    route: '/template/shortvideo.html',
  },
  /**
   * 模板市场-插件
   */
  CHAJIAN: {
    type: 'CHAJIAN',
    name: '模板市场-插件',
    route: '/chajian/',
  },
  /**
   * 模板市场-会员专享
   */
  TEMPLATE_VIP: {
    type: 'TEMPLATE_VIP',
    name: '模板市场-会员专享',
    route: '/template/vip.html',
  },
  /**
   * 模板市场-会员专区
   */
  TEMPLATE_ENTERPRISE: {
    type: 'TEMPLATE_ENTERPRISE',
    name: '模板市场-会员专区',
    route: '/template/enterprise.html',
  },
  /**
   * 模板市场-已收藏模板
   */
  TEMPLATE_MYTPL: {
    type: 'TEMPLATE_MYTPL',
    name: '模板市场-已收藏模板',
    route: '/template/mytpl.html',
  },
  /**
   * 模板市场-搜索结果页
   */
  TEMPLATE_SEARCH: {
    type: 'TEMPLATE_SEARCH',
    name: '模板市场-搜索结果页',
    route: '/template/search.html',
  },
  /**
   * 模板市场-专题页
   */
  TEMPLATE_TOPIC: {
    type: 'TEMPLATE_TOPIC',
    name: '模板市场-专题页',
    route: '/template/topic.html',
  },
};
